// import Button from "components/Common/button";
import React from "react";
import {
  Header,
  MenuContainer,
  MenuItem,
  PageButton,
  Spacer,
  Wrap,
} from "./styles";
import useModal from "hooks/useModal";
import SigninModal from "components/Signup/Modal/SigninModal";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/header/logo.svg";
import { clearUser, getIsUser } from "utils/utility";
// import { Divider } from "@mui/material";
// import Notification from "components/Header/Notification/Notification";
import HeaderLayout from "./HeaderLayout/HeaderLayout";

const AppHeader = () => {
  const navigate = useNavigate();

  const isUser = getIsUser();

  const location = useLocation();

  const {
    isOpen: isOpenSigninModal,
    openModal: openSigninModal,
    closeModal: closeSigninModal,
  } = useModal();

  const handlePage = (path: string) => {
    navigate(`/${path}`);
  };

  const handleLogout = () => {
    clearUser();
    window.location.replace("/data-room");
  };

  return (
    <HeaderLayout>
      <Header>
        <Wrap>
          <img
            className="logoIcon"
            src={logo}
            alt="logoIcon"
            onClick={() => handlePage("data-room")}
          />
          <Spacer width="8.8rem" />

          <MenuContainer>
            <MenuItem
              onClick={() => handlePage("data-room")}
              $isSelected={location.pathname.includes("/data-room")}
            >
              데이터 룸
            </MenuItem>
            <MenuItem
              onClick={() => handlePage("matching")}
              $isSelected={location.pathname.includes("/matching")}
            >
              전문가찾기
            </MenuItem>
            <MenuItem
              onClick={() => handlePage("community")}
              $isSelected={location.pathname.includes("/community")}
            >
              커뮤니티
            </MenuItem>
            <MenuItem
              onClick={() => handlePage("news")}
              $isSelected={location.pathname === "/news"}
            >
              뉴스
            </MenuItem>
          </MenuContainer>
        </Wrap>

        <Wrap className="rightWrapper">
          {/* <Button
            className="membershipButton"
            colorType={"primary"}
            handleClick={() => handlePage("membership")}
          >
            멤버십/열람권
          </Button>
          <Spacer width="1.6rem" />
          <Divider />
          <Spacer />

          <Notification />
          <Spacer /> */}
          {isUser ? (
            <>
              <PageButton onClick={() => handlePage("mypage")}>
                마이페이지
              </PageButton>
              <Spacer />

              <PageButton onClick={handleLogout}>로그아웃</PageButton>
            </>
          ) : (
            <PageButton onClick={openSigninModal}>로그인/회원가입</PageButton>
          )}
        </Wrap>
      </Header>

      {isOpenSigninModal && <SigninModal modalClose={closeSigninModal} />}
    </HeaderLayout>
  );
};

export default AppHeader;
